module.exports = __webpack_public_path__ + "img/Microphone - Green.8018a51e.png";